import React, { useState, useCallback } from 'react';
import { OtaUpdatesOverview } from '../components/otaUpdates/OtaUpdatesOverview';
import { ScheduleUpdateModal } from '../components/otaUpdates/ScheduleUpdateModal';
import { useI18n } from '../contexts/I18nContext';
import '../styles/ota-updates.css';
import { useClientAccess } from '../hooks/useClientAccess';

export const OtaUpdatesPage: React.FC = () => {
  // An ANEP Viewer reads this screen; uploading firmware is a manager's
  // action and the API refuses it for anyone else.
  const { canManageFirmware } = useClientAccess();
  const { formatTime, t } = useI18n();
  const [refreshUpdates, setRefreshUpdates] = useState(0);
  const [lastUpdated, setLastUpdated] = useState<Date>(new Date());
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleRefresh = useCallback(() => {
    setRefreshUpdates(prev => prev + 1);
    setLastUpdated(new Date());
  }, []);

  const handleFirmwareCreated = useCallback(() => {
    // Refresh the list after adding new firmware
    handleRefresh();
  }, [handleRefresh]);

  return (
    <div className="page ota-updates-page">
      <div className="page-header">
        <div className="page-title">
          <h1>{t('otaUpdates.title')}</h1>
          <p>{t('otaUpdates.subtitle')}</p>
        </div>
        <div className="page-actions">
          <div className="last-updated">
            Last updated: {formatTime(lastUpdated)}
          </div>
          <button className="refresh-button" onClick={handleRefresh}>
            Refresh
          </button>
          {canManageFirmware && (
            <button
              className="schedule-update-btn"
              data-testid="btn-add-firmware"
              onClick={() => setIsModalOpen(true)}
            >
              <span className="add-type-icon" aria-hidden="true">+</span>
              Add Firmware
            </button>
          )}
        </div>
      </div>

      <div className="page-content ota-content">
        <OtaUpdatesOverview
          refreshTrigger={refreshUpdates}
        />
      </div>

      <ScheduleUpdateModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onFirmwareCreated={handleFirmwareCreated}
      />
    </div>
  );
};
